






















import { defineComponent } from "@vue/composition-api";
import { sortDocumentsByDate } from "@/tools/msa/utils/sorting";
import Tooltip from "@/components/Tooltip.vue";

export default defineComponent({
  name: "SortButton",
  components: { Tooltip },
  props: {
    session: { type: Object, required: true }
  },
  setup() {
    return {
      confirm: (message: string) => window.confirm(message),
      sort: sortDocumentsByDate
    };
  }
});
